(function () {
  'use strict';

  function initWithdrawalModal() {
    const modal = document.getElementById('withdrawal-modal');

    if (!modal) {
      console.error('[Withdrawal] Modal not found.');
      return;
    }

    const step1 = document.getElementById('wm-step-1');
    const step2 = document.getElementById('wm-step-2');
    const step3 = document.getElementById('wm-step-3');

    const form = document.getElementById('wm-form');

    const nameInput = document.getElementById('wm-name');
    const emailInput = document.getElementById('wm-email');
    const orderInput = document.getElementById('wm-order');

    const nameError = document.getElementById('wm-name-error');
    const emailError = document.getElementById('wm-email-error');
    const orderError = document.getElementById('wm-order-error');

    const backBtn = document.getElementById('wm-back');
    const confirmBtn = document.getElementById('wm-confirm');

    const submitError = document.getElementById('wm-submit-error');

    const i18n = window.withdrawalModalI18n || {};

    let submitting = false;

    console.log('[Withdrawal] Modal initialized.');

    /* ============================================================
       HELPERS
    ============================================================ */

    function delay(ms) {
      return new Promise(function (resolve) {
        setTimeout(resolve, ms);
      });
    }

    function normalize(value) {
      return String(value || '')
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
    }

    function showStep(show, ...hide) {
      if (show) {
        show.hidden = false;
      }

      hide.forEach(function (element) {
        if (element) {
          element.hidden = true;
        }
      });
    }

    function clearSubmitError() {
      if (!submitError) return;

      submitError.textContent = '';
      submitError.hidden = true;
    }

    function showSubmitError(message) {
      console.error('[Withdrawal]', message);

      if (!submitError) return;

      submitError.textContent = message;
      submitError.hidden = false;
    }

    /* ============================================================
       MODAL
    ============================================================ */

    function openModal() {
      modal.classList.add('wm-overlay--visible');
      modal.setAttribute('aria-hidden', 'false');

      document.body.style.overflow = 'hidden';

      clearSubmitError();
    }

    function closeModal() {
      modal.classList.remove('wm-overlay--visible');
      modal.setAttribute('aria-hidden', 'true');

      document.body.style.overflow = '';

      showStep(step1, step2, step3);

      if (form) {
        form.reset();
      }

      submitting = false;

      if (confirmBtn) {
        confirmBtn.disabled = false;
        confirmBtn.textContent = 'Confirm';
      }

      clearSubmitError();
    }

    /* ============================================================
       VALIDATION
    ============================================================ */

    function validate() {
      let valid = true;

      nameError.textContent = '';
      emailError.textContent = '';
      orderError.textContent = '';

      if (!nameInput.value.trim()) {
        nameError.textContent =
          i18n.validationName ||
          'Please enter your full name.';

        valid = false;
      }

      if (
        !emailInput.value.trim() ||
        !emailInput.checkValidity()
      ) {
        emailError.textContent =
          i18n.validationEmail ||
          'Please enter a valid email.';

        valid = false;
      }

      if (!orderInput.value.trim()) {
        orderError.textContent =
          i18n.validationOrder ||
          'Please enter your order number.';

        valid = false;
      }

      return valid;
    }

    /* ============================================================
       STEP 1 → STEP 2
    ============================================================ */

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      if (!validate()) {
        return;
      }

      const name = nameInput.value.trim();
      const email = emailInput.value.trim();

      const order =
        '#' +
        orderInput.value
          .trim()
          .replace(/^#/, '');

      document.getElementById(
        'wm-review-name'
      ).textContent = name;

      document.getElementById(
        'wm-review-email'
      ).textContent = email;

      document.getElementById(
        'wm-review-order'
      ).textContent = order;

      clearSubmitError();

      showStep(
        step2,
        step1,
        step3
      );
    });

    backBtn.addEventListener('click', function () {
      clearSubmitError();

      showStep(
        step1,
        step2,
        step3
      );
    });

    /* ============================================================
       SHOPIFY FORMS
    ============================================================ */

    function getShopifyFormsEmbed() {
      return document.querySelector(
        '[data-forms-id="forms-root-1135745"] shopify-forms-embed'
      );
    }

    /*
      Recursively collect the normal DOM plus every
      accessible/open Shadow DOM underneath Shopify Forms.
    */
    function collectRoots(root, roots) {
      roots = roots || [];

      if (!root) {
        return roots;
      }

      roots.push(root);

      let elements = [];

      try {
        elements = root.querySelectorAll('*');
      } catch (error) {
        return roots;
      }

      elements.forEach(function (element) {
        if (element.shadowRoot) {
          collectRoots(
            element.shadowRoot,
            roots
          );
        }
      });

      return roots;
    }

    function getShopifyRoots() {
      const embed = getShopifyFormsEmbed();

      if (
        !embed ||
        !embed.shadowRoot
      ) {
        return [];
      }

      return collectRoots(
        embed.shadowRoot,
        []
      );
    }

    function queryAcrossShopifyRoots(selector) {
      const results = [];

      getShopifyRoots().forEach(function (root) {
        try {
          root
            .querySelectorAll(selector)
            .forEach(function (element) {
              if (!results.includes(element)) {
                results.push(element);
              }
            });
        } catch (error) {
          // Ignore inaccessible intermediate nodes.
        }
      });

      return results;
    }

    function getFieldDescription(input) {
      let description = [
        input.name,
        input.id,
        input.type,
        input.placeholder,
        input.getAttribute('aria-label'),
        input.getAttribute('autocomplete')
      ]
        .filter(Boolean)
        .join(' ');

      /*
        Match labels from any Shopify Forms Shadow DOM.
      */
      if (input.id) {
        getShopifyRoots().forEach(function (root) {
          try {
            root
              .querySelectorAll('label')
              .forEach(function (label) {
                if (label.htmlFor === input.id) {
                  description +=
                    ' ' +
                    label.textContent;
                }
              });
          } catch (error) {
            // Ignore.
          }
        });
      }

      try {
        const parentLabel = input.closest('label');

        if (parentLabel) {
          description +=
            ' ' +
            parentLabel.textContent;
        }
      } catch (error) {
        // Ignore.
      }

      return normalize(description);
    }

    function identifyShopifyFields() {
      const inputs =
        queryAcrossShopifyRoots(
          'input:not([type="hidden"]), textarea'
        ).filter(function (input) {
          return (
            input.type !== 'submit' &&
            input.type !== 'button' &&
            input.type !== 'checkbox' &&
            input.type !== 'radio'
          );
        });

      let nameField = null;
      let emailField = null;
      let orderField = null;

      inputs.forEach(function (input) {
        const description =
          getFieldDescription(input);

        if (
          !emailField &&
          (
            input.type === 'email' ||
            description.includes('email')
          )
        ) {
          emailField = input;
          return;
        }

        if (
          !orderField &&
          (
            description.includes('order number') ||
            description.includes('order')
          )
        ) {
          orderField = input;
          return;
        }

        if (
          !nameField &&
          (
            description.includes('full name') ||
            description.includes('name')
          )
        ) {
          nameField = input;
        }
      });

      if (
        !nameField ||
        !emailField ||
        !orderField
      ) {
        console.error(
          '[Withdrawal] Could not map Shopify Forms fields.',
          inputs.map(function (input) {
            return {
              type: input.type,
              name: input.name,
              id: input.id,
              placeholder: input.placeholder,
              description:
                getFieldDescription(input)
            };
          })
        );

        return null;
      }

      console.log(
        '[Withdrawal] Shopify Forms fields mapped.',
        {
          name:
            getFieldDescription(nameField),
          email:
            getFieldDescription(emailField),
          order:
            getFieldDescription(orderField)
        }
      );

      return {
        name: nameField,
        email: emailField,
        order: orderField
      };
    }

    async function waitForShopifyForm() {
      const timeout = 15000;
      const started = Date.now();

      while (
        Date.now() - started <
        timeout
      ) {
        const embed = getShopifyFormsEmbed();

        if (
          embed &&
          embed.shadowRoot
        ) {
          const fields =
            identifyShopifyFields();

          const buttons =
            queryAcrossShopifyRoots(
              'button[type="submit"], input[type="submit"]'
            );

          let submitButton = null;

          if (
            fields &&
            buttons.length
          ) {
            submitButton =
              buttons.find(function (button) {
                const text = normalize(
                  button.textContent ||
                  button.value
                );

                return (
                  text.includes('submit') ||
                  text.includes('send')
                );
              }) ||
              buttons[0];
          }

          if (
            fields &&
            submitButton
          ) {
            return {
              embed: embed,
              fields: fields,
              submitButton: submitButton
            };
          }
        }

        await delay(200);
      }

      throw new Error(
        'Shopify Forms did not become ready.'
      );
    }

    /* ============================================================
       WRITE VALUES INTO REAL SHOPIFY FORM
    ============================================================ */

    function setFieldValue(element, value) {
      const win =
        element.ownerDocument.defaultView;

      let prototype;

      if (element.tagName === 'TEXTAREA') {
        prototype =
          win.HTMLTextAreaElement.prototype;
      } else {
        prototype =
          win.HTMLInputElement.prototype;
      }

      const descriptor =
        Object.getOwnPropertyDescriptor(
          prototype,
          'value'
        );

      if (
        descriptor &&
        descriptor.set
      ) {
        descriptor.set.call(
          element,
          value
        );
      } else {
        element.value = value;
      }

      element.dispatchEvent(
        new win.Event(
          'input',
          {
            bubbles: true,
            composed: true
          }
        )
      );

      element.dispatchEvent(
        new win.Event(
          'change',
          {
            bubbles: true,
            composed: true
          }
        )
      );

      element.dispatchEvent(
        new win.Event(
          'blur',
          {
            bubbles: true,
            composed: true
          }
        )
      );
    }

    /* ============================================================
       SUCCESS DETECTION
    ============================================================ */

    function getShopifyFormsText() {
      let text = '';

      getShopifyRoots().forEach(function (root) {
        try {
          text +=
            ' ' +
            (root.textContent || '');
        } catch (error) {
          // Ignore.
        }
      });

      return normalize(text);
    }

    async function waitForShopifySuccess() {
      const timeout = 20000;
      const started = Date.now();

      while (
        Date.now() - started <
        timeout
      ) {
        const text =
          getShopifyFormsText();

        /*
          Your configured Shopify Forms message:
          "Thank you. The form has been submitted."
        */
        if (
          text.includes('thank you') &&
          text.includes('submitted')
        ) {
          return true;
        }

        /*
          Future-proof if we change the message.
        */
        if (
          text.includes(
            'withdrawal request received'
          )
        ) {
          return true;
        }

        await delay(250);
      }

      throw new Error(
        'Shopify Forms did not confirm the submission.'
      );
    }

    /* ============================================================
       REAL SUBMISSION
    ============================================================ */

    async function submitWithdrawal(data) {
      const shopifyForm =
        await waitForShopifyForm();

      console.log(
        '[Withdrawal] Populating real Shopify Form.'
      );

      setFieldValue(
        shopifyForm.fields.name,
        data.name
      );

      setFieldValue(
        shopifyForm.fields.email,
        data.email
      );

      setFieldValue(
        shopifyForm.fields.order,
        data.order
      );

      await delay(400);

      if (shopifyForm.submitButton.disabled) {
        throw new Error(
          'Shopify Forms submit button is disabled.'
        );
      }

      console.log(
        '[Withdrawal] Submitting real Shopify Form.'
      );

      shopifyForm.submitButton.click();

      await waitForShopifySuccess();

      return true;
    }

    /* ============================================================
       CONFIRM
    ============================================================ */

    confirmBtn.addEventListener(
      'click',
      async function () {
        if (submitting) {
          return;
        }

        const name =
          nameInput.value.trim();

        const email =
          emailInput.value.trim();

        const order =
          '#' +
          orderInput.value
            .trim()
            .replace(/^#/, '');

        clearSubmitError();

        submitting = true;
        confirmBtn.disabled = true;

        const originalText =
          confirmBtn.textContent;

        confirmBtn.textContent =
          i18n.submitting ||
          'Submitting…';

        try {
          await submitWithdrawal({
            name: name,
            email: email,
            order: order
          });

          const timestamp =
            new Date().toLocaleString(
              'en-GB',
              {
                day: 'numeric',
                month: 'long',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                timeZoneName: 'short'
              }
            );

          document.getElementById(
            'wm-success-order'
          ).textContent = order;

          document.getElementById(
            'wm-success-timestamp'
          ).textContent = timestamp;

          const successEmail =
            document.getElementById(
              'wm-success-email'
            );

          if (successEmail) {
            successEmail.textContent =
              email;
          }

          console.log(
            '[Withdrawal] Shopify Forms submission successful.'
          );

          showStep(
            step3,
            step1,
            step2
          );
        } catch (error) {
          console.error(
            '[Withdrawal] Submission failed:',
            error
          );

          showSubmitError(
            i18n.submissionError ||
            'We could not submit your withdrawal request. Please try again. If the problem continues, contact Customer Service at eshop@wendre.com.'
          );
        } finally {
          submitting = false;
          confirmBtn.disabled = false;
          confirmBtn.textContent =
            originalText;
        }
      }
    );

    /* ============================================================
       OPEN / CLOSE
    ============================================================ */

    document.addEventListener(
      'click',
      function (event) {
        /*
          Supports both:
          <a href="#withdrawal-modal">HERE</a>

          and:
          <button data-withdrawal-open>Open</button>
        */
        const openButton =
          event.target.closest(
            '[data-withdrawal-open], a[href="#withdrawal-modal"]'
          );

        if (openButton) {
          event.preventDefault();
          openModal();
          return;
        }

        const closeButton =
          event.target.closest(
            '[data-withdrawal-close]'
          );

        if (closeButton) {
          event.preventDefault();
          closeModal();
          return;
        }

        if (event.target === modal) {
          closeModal();
        }
      }
    );

    document.addEventListener(
      'keydown',
      function (event) {
        if (
          event.key === 'Escape' &&
          modal.classList.contains(
            'wm-overlay--visible'
          )
        ) {
          closeModal();
        }
      }
    );

    /*
      Also opens the modal from URLs such as:
      https://example.com/page?withdraw=1
    */
    if (
      new URLSearchParams(
        window.location.search
      ).get('withdraw') === '1'
    ) {
      openModal();
    }

    /*
      Opens the modal if the page itself is loaded with:
      https://example.com/page#withdrawal-modal
    */
    if (
      window.location.hash ===
      '#withdrawal-modal'
    ) {
      openModal();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initWithdrawalModal
    );
  } else {
    initWithdrawalModal();
  }
})();